import i18n from '@i18next/i18n';
import { TENANT_CONFIG } from '@src/slide/infrastructure/module/dependent/config/tob/constant';

/** 获取文档分享链接；如果从 location 取值，则清除所有的 query/hash */
export const getShareLink = () => window.clientVars?.shortLink || window.location.href.split(/\?|#/)[0];

export const getShareTitle = () => window.clientVars?.title || window.clientVars?.padTitle;

/** 复制文档链接文本 */
export const copyDocLinkText = (copyText: (href: string) => void) => {
    const copyLinkString = `${
        TENANT_CONFIG.TENANT_DOC_NAME ? `【${TENANT_CONFIG.TENANT_DOC_NAME}】` : i18n.t('【腾讯文档】')
    }${getShareTitle() || ''}\n${getShareLink() || ''}`;
    copyText(copyLinkString);
};
